
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const news = createApi({
    reducerPath: 'news',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['News'],
    endpoints: (builder) => ({
        getNews: builder.query({
            query: ({ page = 1, limit = 10, search }) => `/api/news/get-news?page=${page}&limit=${limit}&search=${search}`,
            providesTags: (result, error, { page, limit }) => [
                { type: 'News', id: `page-${page}-limit-${limit}` },
            ],
        }),

        createNews: builder.mutation({
            query: (data) => ({
                url: `/api/news/create-new-news`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['News'],
        }),

        deleteNews: builder.mutation({
            query: (id) => ({
                url: `/api/news/delete-news/${id}`,  // Send the `id` as a query parameter
                method: 'DELETE',  // Or DELETE if your backend expects DELETE
            }),
            invalidatesTags: ['News'],
        }),


        updateNews: builder.mutation({
            query: (data) => ({
                url: `/api/news/update-news`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['News'],
        }),
    }),
});

export const {
    useGetNewsQuery,
    useCreateNewsMutation,
    useDeleteNewsMutation,
    useUpdateNewsMutation
} = news;